import { useTranslation } from 'react-i18next'

import { RemainingMinutesWidget, StatisticWidget } from '../../../../types/widget/widget'
import { today, toDisplayMonthYear } from '../../../../utils/dateUtils'
import { formatMinutes } from '../../../../utils/booking/booking'
import { remainingMinutesProgress } from '../remainingSessions/RemainingMinutes'

type MonthlyActivityCardProps = {
  playedSessions: StatisticWidget | null
  minutes?: RemainingMinutesWidget | null
}

export const MonthlyActivityCard = ({
  playedSessions,
  minutes,
}: MonthlyActivityCardProps) => {
  const { t, i18n } = useTranslation('dashboard')
  const changePercentage = playedSessions?.changePercentage
  const hasData = playedSessions != null
  const progress = minutes ? remainingMinutesProgress(minutes) : null

  return (
    <div className="monthly-activity-card">
      <div className="eyebrow monthly-activity-period">
        {t('dashboard.monthly-activity-card.period', {
          month: toDisplayMonthYear(today(), i18n.language),
        })}
      </div>

      <div className="ph-row monthly-activity-content">
        <span className="display monthly-activity-value">
          {hasData ? playedSessions.value : '—'}
        </span>

        <span className="monthly-activity-label">
          {t(
            hasData
              ? 'dashboard.monthly-activity-card.label'
              : 'dashboard.monthly-activity-card.no-data'
          )}
        </span>

        {!hasData ? null : changePercentage == null ? (
          <span className="muted tiny">
            {t('dashboard.monthly-activity-card.no-previous-data')}
          </span>
        ) : (
          <span className="badge badge-accent monthly-activity-change">
            {changePercentage > 0 && '+'}
            {changePercentage}%
          </span>
        )}
      </div>

      {minutes && progress && (
        <div className="monthly-activity-minutes d-lg-none">
          <div className="ph-row ph-between monthly-activity-minutes-row">
            <span>{t('dashboard.remaining-minutes.title')}</span>
            <span>
              <strong className="display">
                {formatMinutes(progress.available)}
              </strong>{' '}
              {t('dashboard.remaining-minutes.left', {
                total: formatMinutes(progress.total),
              })}
            </span>
          </div>
          <div className="monthly-activity-minutes-bar">
            <div
              className="monthly-activity-minutes-fill"
              style={{ width: `${progress.pct}%` }}
            />
          </div>
          <div className="mono monthly-activity-minutes-passes">
            {t('dashboard.remaining-minutes.active-passes', {
              count: minutes.activePassesNumber,
            })}
          </div>
        </div>
      )}
    </div>
  )
}
